import React, { useEffect, useState, memo } from "react";
import axios from "axios";
import DiscountModal from "./DiscountModal";

const DiscountHistory = ({
  show,
  setshow,
  handleClose,
  handleReApply,
  selectedApplication,
  viewTicketData,
}) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const BASE_URL = process.env.REACT_APP_BOOKING_BASE_URL;
  const TOKEN =
    localStorage.getItem("access_token") ||
    localStorage.getItem("access_token_admin");

  useEffect(() => {
    if (!selectedApplication?.application_id) return;

    const fetchHistory = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${BASE_URL}/api/auth/discount/users/track_application/${selectedApplication.application_id}`,
          {
            headers: {
              Authorization: TOKEN,
              Accept: "application/json",
            },
          }
        );

        // ✅ Adjust for actual API structure
        if (res?.data?.application?.application_track) {
          setHistoryData(
            res.data.application.application_track.map((trackItem) => ({
              ...trackItem,
              application_id: res.data.application.application_id,
            }))
          );
        } else {
          setHistoryData([]);
        }
      } catch (err) {
        console.error("Error fetching discount history:", err);
        setHistoryData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [selectedApplication]);

  if (!show) return null;

  function formatDateOnly(str) {
    if (!str) return "";
    const [datePart] = str.split(" ");
    const dateObj = new Date(datePart);
    return dateObj.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  return (
    <>
      <style>{`
        .timeline-container {
          position: relative;
          // padding-left: 30px;
        }

        .timeline-item {
          position: relative;
          margin-bottom: 2rem;
        }

        .timeline-line {
          position: absolute;
          left: -6px;
          top: 24px;
          bottom: 80px;
          width: 1px;
          background-image: repeating-linear-gradient(
            to bottom,
            rgb(84, 86, 94) 0px,
            rgb(84, 86, 94) 4px,
            transparent 7px,
            transparent 12px
          );
        }

        .timeline-dot {
          position: absolute;
          left: -17px;
          width: 22px;
          height: 20px;
          border: 2px solid #8243E6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99;
        }

        .timeline-dot::before {
          content: "";
          width: 10px;
          height: 8px;
          background-color: #8b5cf6;
          border-radius: 50%;
        }

        .timeline-item:last-child .timeline-line {
          display: none;
        }

        .status-pending {
          color: #fd7e14;
          font-weight: 500;
        }

        .status-approved {
          color: #198754;
          font-weight: 500;
        }

        .badge-gold {
          background-color: #fff3cd !important;
          color: #FFA500 !important;
          border-radius: 50px;
          font-size: 10px;
        }

        .badge-silver {
          background-color: #FFFAF2 !important;
          color: #FFA500 !important;
          border-radius: 50px;
          font-size: 10px;
        }

        .badge-blue {
         background-color: #FFFAF2 !important;
          color: #FFCC00 !important;
          border-radius: 50px;
          font-size: 10px;
        }
          .badge-green {
            background-color: #EDF6F0 !important;
          color: #4AA564 !important;
          border-radius: 50px;
          font-size: 10px;
          }

          .badge-reject {
            background-color: #FAEAEA !important;
          color: #DC3545 !important;
          border-radius: 50px;
          font-size: 10px;
          }

.discount-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  overflow-y: auto; /* 👈 enables scrolling */
  padding: 10px; /* optional, for spacing when scrolled */
}

.discount-modal {
  background: #fff;
  border-radius: 10px;
  max-height: 100vh; /* 👈 keeps modal inside viewport */
  overflow-y: auto; /* 👈 makes modal content scrollable */
  width: 500px; /* adjust as per your design */
  padding: 20px;
}


        .discount-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.25rem;
          border-bottom: 1px solid #eee;
         
        }

        .discount-modal-header h5 {
          margin: 0;
          font-weight: 500;
          font-size: 20px;
        }

        .close-btn {
          cursor: pointer;
          background: none;
          border: none;
          font-size: 1.8rem;
          color: #333;
        }

        .discount-modal-body {
          padding: 1.5rem;
        }

        .gold-history {
        font-size: 14px;
        line-height: 150%;
        color: #6B7280;
        font-weight:400;
        }
        .silver-history {
           font-size: 14px;
        line-height: 150%;
        color: #6B7280;
        font-weight:400;
        }
      `}</style>

      <div className="discount-modal-overlay" onClick={handleClose}>
        <div className="discount-modal" onClick={(e) => e.stopPropagation()}>
          <div className="discount-modal-header">
            <h5>Apply For Discount History</h5>
            <button className="close-btn" onClick={handleClose}>
              &times;
            </button>
          </div>

          <div className="discount-modal-body">
            {loading ? (
              <p className="text-center text-muted py-4">Loading history...</p>
            ) : historyData?.length > 0 ? (
              <div className="timeline-container">
                <div className="timeline-line"></div>
                {historyData.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="ms-4">
                      <div className="row align-items-start mb-1">
                        <div className="col">
                          <h6 className="mb-0 fw-normal fs-5 pb-2">
                            {item?.application_status
                              ? item.application_status.toLowerCase() ===
                                "reopened"
                                ? "Re-Applied"
                                : item.application_status
                                    .charAt(0)
                                    .toUpperCase() +
                                  item.application_status.slice(1)
                              : "-"}
                          </h6>
                        </div>
                        <div className="col-auto">
                          <small className="text-muted">
                            {formatDateOnly(item.applied_on)
                              ? formatDateOnly(item.applied_on)
                              : item.updated_at
                              ? new Date(item.updated_at).toLocaleDateString()
                              : "-"}
                          </small>
                        </div>
                      </div>

                      <div className="row align-items-center mb-2">
                        <div className="col">
                          <small className="text-muted">
                            {item.category || item.applied_for || "-"}
                          </small>
                        </div>
                        <div className="col-auto">
                          <span
                            className={` ${
                              item.medal_type === "Golden"
                                ? "gold-history"
                                : "silver-history"
                            } px-2 py-1`}
                          >
                            {item.medal_type || "-"}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-2">
                        <div className="col">
                          <small className="py-1 text-muted">
                            {item.application_status === "approved"
                              ? "Approved From Admin Side"
                              : item.adminStatus ||
                                item.remark ||
                                "Waiting for Admin Action"}
                          </small>
                        </div>

                        <div className="col-auto">
                          <span
                            className={`status ${
                              (item.adminStatusType ||
                                item.application_status) === "Pending"
                                ? "badge-gold"
                                : (item.adminStatusType ||
                                    item.application_status) === "reopened"
                                ? "badge-blue"
                                : (item.adminStatusType ||
                                    item.application_status) === "approved"
                                ? "badge-green"
                                : (item.adminStatusType ||
                                    item.application_status) === "rejected"
                                ? "badge-reject"
                                : "badge-silver"
                            } px-2 py-1`}
                          >
                            {item?.application_status
                              ? item.application_status.toLowerCase() ===
                                "reopened"
                                ? "Re-Apply"
                                : item.application_status
                                    .charAt(0)
                                    .toUpperCase() +
                                  item.application_status.slice(1)
                              : "-"}
                          </span>
                        </div>
                      </div>
                      {item.application_status == "rejected" && (
                        <div className="row align-items-center mb-2">
                          <div className="col">
                            <small className="py-1 text-muted">
                              Rejected From Admin Side
                            </small>
                          </div>
                          <div></div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                {historyData?.length > 0 &&
                  historyData[
                    historyData.length - 1
                  ]?.application_status?.toLowerCase() === "reopened" && (
                    <div className="d-flex justify-content-end mt-5">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          const last = historyData[historyData.length - 1];
                          handleReApply(
                            last.applied_for,
                            last.medal_type,
                            last.application_id,
                            last.remark
                          );
                        }}
                      >
                        Re-Apply
                      </button>
                    </div>
                  )}
              </div>
            ) : (
              <p className="text-center text-muted py-4">
                No history data available.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(DiscountHistory);
